import { makeAutoObservable } from 'mobx';

// View modes: "grid" | "table" | "advancedTable"
class ViewStore {
    viewMode = "table";
  
    constructor() {
      makeAutoObservable(this);
      this.loadView();
    }
  
    setViewMode(value) {
      this.viewMode = value;
      localStorage.setItem('viewMode', value);
    }

    // Legacy support
    setTableView(value) {
      this.viewMode = value ? "table" : "grid";
      localStorage.setItem('viewMode', this.viewMode);
    }
  
    async loadView() {
      try {
        const value = localStorage.getItem('viewMode');
        if (value !== null) {
          this.viewMode = value;
        } else {
          // Legacy migration
          const legacyValue = localStorage.getItem('isTableView');
          if (legacyValue !== null) {
            this.viewMode = JSON.parse(legacyValue) ? "table" : "grid";
            localStorage.setItem('viewMode', this.viewMode);
            localStorage.removeItem('isTableView');
          }
        }
      } catch (error) {
        console.error('Error loading view mode:', error);
      }
    }
  
    get getViewMode() {
      return this.viewMode;
    }

    // Legacy support
    get getIsTableView() {
      return this.viewMode === "table" || this.viewMode === "advancedTable";
    }

    get isAdvancedTable() {
      return this.viewMode === "advancedTable";
    }

    get isGrid() {
      return this.viewMode === "grid";
    }
}

export default new ViewStore();